<template>
  <div id="main">
    <Header />
    <div class="main-content">
      <div class="detail">
        <router-view />
      </div>
    </div>
    <Footer />
    <cookie-law />
  </div>
</template>

<script>
import Header from "../components/Header.vue";
import Footer from "../components/Footer.vue";
import CookieLaw from "vue-cookie-law";

export default {
  name: "Layout",
  components: { Header, Footer, CookieLaw },
};
</script>

<style lang="scss" scoped>
#main {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.logo-container {
  width: 100px;
}
.main-content {
  display: flex;
  flex: 1;

  .detail {
    flex: 1;
  }
}
@media (max-width: 767px) {
  .detail {
    overflow-x: hidden;
    overflow-y: auto;
  }
}
</style>
